import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

function fmtErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back");
      nav("/");
    } catch (err) {
      toast.error(fmtErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0A0C10] relative z-10">
      <div
        className="hidden lg:block relative"
        style={{
          backgroundImage:
            "linear-gradient(120deg, rgba(10,12,16,0.4), rgba(10,12,16,0.9)), url('https://images.unsplash.com/photo-1731239027673-1a5c6cd61380?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400')",
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      >
        <div className="absolute bottom-12 left-12 right-12">
          <div className="eyebrow text-[#D4AF37]">The Passport Experience™</div>
          <h1 className="font-display text-5xl text-[#F8FAFC] mt-3 leading-tight">
            Your personal creative<br />marketing director.
          </h1>
          <p className="text-[#94A3B8] mt-4 max-w-md">
            Thailand 2027. Open it each morning and know exactly what to post, who to say it to, and why — then create it in a few clicks.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="flex items-center gap-3 mb-8">
            <img src="/inforno-logo.png" alt="Inforno Travel" className="h-11 w-auto" />
            <span className="font-display text-2xl">Inforno Travel</span>
          </div>
          <h2 className="text-xl font-semibold mb-1">Owner sign in</h2>
          <p className="text-sm text-[#94A3B8] mb-6">Private internal marketing system.</p>
          <label className="block text-sm text-[#94A3B8] mb-1">Email</label>
          <input
            data-testid="login-email"
            type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full mb-4 px-4 py-3 rounded-lg bg-[#12151E] border border-[#2A3042] focus:border-[#D4AF37] outline-none text-[#F8FAFC]"
          />
          <label className="block text-sm text-[#94A3B8] mb-1">Password</label>
          <input
            data-testid="login-password"
            type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full mb-2 px-4 py-3 rounded-lg bg-[#12151E] border border-[#2A3042] focus:border-[#D4AF37] outline-none text-[#F8FAFC]"
          />
          <div className="flex justify-end mb-6">
            <Link to="/forgot-password" data-testid="forgot-password-link"
              className="text-sm text-[#D4AF37] hover:text-[#E5C158] transition-colors">
              Forgot password?
            </Link>
          </div>
          <button
            data-testid="login-submit"
            type="submit" disabled={loading}
            className="gold-btn w-full py-3 rounded-lg disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
